import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { HomeIcon, GroupIcon, ChatIcon } from '../../Svg/Index.js'
import { SET_INBOX } from '../../Actions/Chat'



class Navbar extends Component {
    componentDidMount() {
        // this.props.actions.SET_INBOX().then(()=> {
        // })
    }

    render() {
        const { inbox } = this.props
        
        let unreadThreads = inbox.filter(r => r.unread).length

        return (
            <div className="c-nav">
                <div className="o-spacer"></div>
                <div className="c-nav__inner">
                    <NavLink activeClassName="is-active" to="/messages">
                        <ChatIcon />
                        {
                            unreadThreads > 0 && (
                                <span className="c-inbox-count">{unreadThreads}</span>
                            )
                        }
                    </NavLink >
                    <NavLink activeClassName="is-active" to="/wazzup">
                        <HomeIcon />
                    </NavLink >
                    <NavLink activeClassName="is-active" to="/community/groups">
                        <GroupIcon />
                    </NavLink >
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        inbox: state.chat.inbox
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_INBOX}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)